/** A branch's day as its hours say: shared by Home's status line and the Floor's. */

export type HoursOf = { openingHours?: ReadonlyArray<{ day: number; open: number; close: number }>; openNow?: boolean; timezone?: string }

/** The weekday (0 is Sunday) at a moment, on the branch's clock. */
function weekdayIn(now: Date, zone: string | undefined): number {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: zone || undefined }).formatToParts(now)
    const part = (type: string) => Number(parts.find((p) => p.type === type)?.value)
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day'))).getUTCDay()
  } catch {
    return now.getDay()
  }
}

/** What the status line says about the hours: none kept, open all day, or open or closed now. */
export function branchHours(branch: HoursOf, now: Date): 'none' | 'allDay' | 'open' | 'closed' {
  const week = branch.openingHours ?? []
  if (week.length === 0) return 'none'
  if (branch.openNow === false) return 'closed'
  const today = weekdayIn(now, branch.timezone)
  // Today's rows, joined, must run unbroken from 00:00 to 24:00.
  let reach = 0
  for (const d of week.filter((d) => d.day === today).sort((a, b) => a.open - b.open)) {
    if (d.open > reach) break
    reach = Math.max(reach, d.close)
  }
  return reach >= 1440 ? 'allDay' : 'open'
}
